import { NG_VALIDATORS, FormControl, Validator } from '@angular/forms';
import { Directive } from '@angular/core';

import { AnjunaValidators } from '../models/AnjunaValidators';
import { DateValidationResult } from '../interfaces/DateValidationResult';

/* tslint:disable:directive-selector */
@Directive({
    selector: '[date][ngModel],[date][formControl]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: DateValidatorDirective, multi: true }
    ]
})
export class DateValidatorDirective implements Validator {
    validate(c: FormControl): DateValidationResult {
        return AnjunaValidators.date(c);
    }
}
